export enum PERCENT {
    Empty = 0,
    Quarter = 25,
    Full = 100,
}
